// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";

// import "swiper/css";

// const VehicleFleetSection = () => {
//   const vehicles = [
//     {
//       name: "Maruti Ertiga",
//       price: "₹14",
//       image: "/images/Fleet/Maruti-Ertiga.jpg",
//       seats: "6+1 Seat",
//       bags: "3 Bags",
//       type: "MPV",
//       fuel: "Petrol / CNG",
//     },
//     {
//       name: "Toyota Rumion",
//       price: "₹15",
//       image: "/images/Fleet/Toyota-Rumion.jpg",
//       seats: "6+1 Seat",
//       bags: "3 Bags",
//       type: "MPV",
//       fuel: "Petrol / CNG",
//     },
//     {
//       name: "Kia Carens",
//       price: "₹16",
//       image: "/images/Fleet/Kia-Carens.jpg",
//       seats: "6+1 Seat",
//       bags: "3 Bags",
//       type: " MPV",
//       fuel: "Petrol / Diesel",
//     },
   
//     {
//       name: "Innova Crysta",
//       price: "₹22",
//       image: "/images/Fleet/Innova-Crysta.jpeg",
//       seats: "6+1 Seat",
//       bags: "4 Bags",
//       type: " MPV",
//       fuel: "Diesel",
//     },
//   ];

//   return (
//     <div
//       className="section-full py-2 site-bg-white twm-blog-section-wrap wow fadeInDown   bgh"
//       data-wow-offset="100"
//       data-wow-delay="0.2"
//     >
//       <div className="container-fluid">

//         {/* TITLE START */}
//         <div className="section-head center">
//           <div className="twm-sm-title left text-dark">
//             Choose Your Cab
//           </div>

//           <h2 className="twm-large-title site-text-dark">
//             Our Cab Fleet
//           </h2>
//         </div>
//         {/* TITLE END */}

//         <div className="section-content">
//           <Swiper
//             modules={[Autoplay]}
//             className="twm-vehicle-fleet-carousel m-b30"

//             autoplay={{
//               delay: 2500,
//               disableOnInteraction: false,
//               pauseOnMouseEnter: true,
//             }}

//             loop={true}

//             spaceBetween={30}

//             breakpoints={{
//               0: {
//                 slidesPerView: 1,
//               },
//               576: {
//                 slidesPerView: 2,
//               },
//               992: {
//                 slidesPerView: 3,
//               },
//               1200: {
//                 slidesPerView: 3,
//               },
//               1600: {
//                 slidesPerView: 5,
//               },
//             }}
//           >
//             {vehicles.map((vehicle, index) => (
//               <SwiperSlide key={index}>

//                 <div className="twm-vehicle-fleet-bx">

//                   {/* Vehicle Image */}
//                   <div className="twm-media">

//                     <div className="twm-media-pic">
//                       <img
//                         src={vehicle.image}
//                         alt={`${vehicle.name} - Garud Cab Service`}
//                       />
//                     </div>

//                   </div>

//                   {/* Vehicle Content */}
//                   <div className="twm-vehicle-fleet-content">

//                     <h3 className="twm-v-title textp text-darkfff">
//                       <a href="/booking" className="text-darkfff">
//                         {vehicle.name}
//                       </a>
//                     </h3>

//                     {/* Vehicle Facilities */}
//                     <ul className="twm-vehicle-facility">

//                       <li>
//                         <span>
//                           <img
//                             src="/images/icons/car-seat.png"
//                             alt="Seats"
//                           />
//                         </span>
//                         {vehicle.seats}
//                       </li>

//                       <li>
//                         <span>
//                           <img
//                             src="/images/icons/bag.png"
//                             alt="Bags"
//                           />
//                         </span>
//                         {vehicle.bags}
//                       </li>

//                       <li>
//                         <span>
//                           <img
//                             src="/images/icons/car.png"
//                             alt="Vehicle Type"
//                           />
//                         </span>
//                         {vehicle.type}
//                       </li>

//                     </ul>

//                     {/* Fuel Type */}
//                     <ul className="twm-vehicle-fuel-type">
//                       <li>
//                         {vehicle.fuel}
//                       </li>
//                     </ul>

//                   </div>

//                 </div>

//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default VehicleFleetSection;




import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const VehicleFleetSection = () => {
  const vehicles = [
   {
  name: "Swift Dzire",
  price: "₹14",
  image: "/images/Fleet/Swift-Dzire.jpeg",
  seats: "4+1 Seat",
  bags: "2 Bags",
  type: "Sedan",
  fuel: "Petrol / CNG",
},

    {
      name: "Maruti Ertiga",
      price: "₹14",
      image: "/images/Fleet/Maruti-Ertiga.jpg",
      seats: "6+1 Seat",
      bags: "3 Bags",
      type: "MPV",
      fuel: "Petrol / CNG",
    },
   
    {
      name: "Kia Carens",
      price: "₹16",
      image: "/images/Fleet/Kia-Carens.jpg",
      seats: "6+1 Seat",
      bags: "3 Bags",
      type: "MPV",
      fuel: "Petrol / Diesel",
    },
    {
      name: "Innova Crysta",
      price: "₹22",
      image: "/images/Fleet/Innova-Crysta.jpeg",
      seats: "6+1 Seat",
      bags: "4 Bags",
      type: "MPV",
      fuel: "Diesel",
    },


    //  {
    //   name: "Toyota Rumion",
    //   price: "₹15",
    //   image: "/images/Fleet/Toyota-Rumion.jpg",
    //   seats: "6+1 Seat",
    //   bags: "3 Bags",
    //   type: "MPV",
    //   fuel: "Petrol / CNG",
    // },
  ];

  return (
    <section className="garud-fleet-section">

      <div className="container">

        {/* ================= HEADER ================= */}
        <div className="garud-fleet-heading">

          <div className="garud-fleet-small-title">
            <span></span>
            CHOOSE YOUR CAB
            <span></span>
          </div>

          <h2>
            Our <strong>Cab Fleet</strong>
          </h2>

          <p>
            Comfortable, clean and well-maintained vehicles for
            Pune city rides, airport transfers and outstation journeys.
          </p>

        </div>


        {/* ================= SLIDER ================= */}
        <div className="garud-fleet-slider">

          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 2800,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            spaceBetween={22}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
              1400: {
                slidesPerView: 4,
              },
            }}
          >

            {vehicles.map((vehicle, index) => (

              <SwiperSlide key={index}>

                <div className="garud-vehicle-card">

                  {/* IMAGE */}
                  <div className="garud-vehicle-image">

                    <img
                      src={vehicle.image}
                      alt={`${vehicle.name} - Garud Cab Service`}
                    />

                    {/* PRICE */}
                    {/* <div className="garud-vehicle-price">
                      <small>Starting</small>
                      <strong>{vehicle.price}</strong>
                      <span>/ KM</span>
                    </div> */}

                    {/* VEHICLE TYPE */}
                    <div className="garud-vehicle-type">
                      {vehicle.type}
                    </div>

                  </div>


                  {/* CONTENT */}
                  <div className="garud-vehicle-content">

                    <h3>
                      {vehicle.name}
                    </h3>


                    {/* FACILITIES */}
                    <div className="garud-vehicle-facilities">

                      <div className="garud-facility">

                        <div className="garud-facility-icon">
                          <img
                            src="/images/icons/car-seat.png"
                            alt="Seats"
                          />
                        </div>

                        <span>{vehicle.seats}</span>

                      </div>


                      <div className="garud-facility">

                        <div className="garud-facility-icon">
                          <img
                            src="/images/icons/bag.png"
                            alt="Bags"
                          />
                        </div>

                        <span>{vehicle.bags}</span>

                      </div>


                      <div className="garud-facility">

                        <div className="garud-facility-icon">
                          <img
                            src="/images/icons/car.png"
                            alt="Vehicle"
                          />
                        </div>

                        <span>{vehicle.type}</span>

                      </div>

                    </div>


                    {/* FUEL */}
                    <div className="garud-vehicle-fuel">

                      <i className="fa fa-tint"></i>

                      <span>{vehicle.fuel}</span>

                    </div>


                    {/* BOOK BUTTON */}
                    <a
                      href="/booking"
                      className="garud-vehicle-book"
                    >
                      <span>Book Now</span>

                      <i className="fa fa-arrow-right"></i>
                    </a>

                  </div>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>

        </div>

      </div>

    </section>
  );
};

export default VehicleFleetSection;
